import { TConfig } from '@fe-core';
import { TSelfregSessionDetails } from '@api/io/selfreg.io';

export type TSelfregSessionStates =
  | 'sessionFull'
  | 'waitlistAvailable'
  | 'placedInWaitlist'
  | 'numberedPlaceInWaitlist'
  | 'enrollmentPending';

export const getSessionStates = (
  sessionDetails: TSelfregSessionDetails,
  webfeatures: TConfig['config']['webfeatures'],
): Record<TSelfregSessionStates, boolean> => {
  const { enrollment, waitlist, selfEnrollmentStatus, selfEnrollmentProgress } =
    sessionDetails;

  const enrollmentOverLimit = !!(
    enrollment?.maximum?.limit &&
    enrollment.current?.limit &&
    enrollment.maximum.limit <= enrollment.current.limit
  );

  const isEnrolled = selfEnrollmentStatus === 'active';
  const inWaitlist =
    !!webfeatures?.['waitlist'] &&
    waitlist?.enabled &&
    waitlist?.seatNumber != null;

  const enrollmentPending =
    !inWaitlist &&
    selfEnrollmentStatus === 'enrolled_confirmed' &&
    selfEnrollmentProgress === 'unknown';

  return {
    // enrollment related
    sessionFull: !isEnrolled && enrollmentOverLimit,

    // waitlist related
    placedInWaitlist: inWaitlist && !waitlist.displayDetails,
    numberedPlaceInWaitlist: inWaitlist && waitlist.displayDetails,
    waitlistAvailable:
      !!webfeatures?.['waitlist'] &&
      waitlist.enabled &&
      waitlist.seatsAvailable,
    enrollmentPending,
  };
};
